module.exports = __webpack_public_path__ + "img/w-digital-marketing.0611a697.svg";